'use client';

import { InboxPage } from 'app/(appHeader)/inbox/InboxPage';

export default function Page() {
  return (
    <>
      <title>알림 | 디리토</title>
      <InboxPage />
    </>
  );
}
